import React from 'react'
import Styles from './styles.module.sass'

const CardCreditoSears = (props) => {
    const {
        numeroTarjeta,
        nombreTitular
    } = props

    return(
        <div className={Styles?.boxTarjeta}>
            <div className={Styles?.img}>
                <div className={Styles?.imaTarjeta}>
                    <div className={Styles?.numeroTarjeta}>
                        <span>{numeroTarjeta}</span>
                    </div>
                    <div className={Styles?.titular}>
                        <span>{nombreTitular}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardCreditoSears